// extracted by mini-css-extract-plugin
module.exports = {"detail_container":"DetailPage_detail_container__K5py-"};